import {useEffect, useState} from "react";

export function useScrolledFromTop(offset: number = 0): boolean {
    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.scrollY > offset;

            setHasScrolled(scrolled);
        };

        window.addEventListener("scroll", handleScroll, {passive: true});

        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, [offset]);

    return hasScrolled;
}
import {useEffect, useState} from "react";

export function useScrolledFromTop(offset: number = 0): boolean {
    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.scrollY > offset;

            setHasScrolled(scrolled);
        };

        window.addEventListener("scroll", handleScroll, {passive: true});

        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, [offset]);

    return hasScrolled;
}
